import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { Inscats, EmailDomains, SysOptionReq, Codes } from 'bff/models/info';
import { BaseRes } from 'bff/models/base/baseRes';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptions } from 'bff/models/info/sysoptions';
import { ClaimAddRes, ClaimPolicyNos } from 'bff/models/member';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { LinkCategory } from 'constants/enums/linkCategory.enum';
import { DocCompensation, Links } from 'bff/models/link';

/**
 * @description 取得初始化資料
 */
const fetchInitSetting = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.CLAIM_ATT]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchEmailDN(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.COMPENSATION),
    apiService.fetchLinkByCategory(baseReq, reqConfig, LinkCategory.DocCompensation),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([inscatRes, emailDomainsRes, sysOptRes, compensationCodeRes, docCompensationLinksRes, UICodeRes]) => {
    const inscatBaseRes: BaseRes<Inscats> = { ...inscatRes };
    const emailDomainsBaseRes: BaseRes<EmailDomains> = { ...emailDomainsRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const compensationBaseRes: BaseRes<Codes> = { ...compensationCodeRes };
    const docCompensationBaseRes: BaseRes<Links<DocCompensation>> = { ...docCompensationLinksRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };

    const res = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      emailDomains: commonService.arrayTypeReturn(emailDomainsBaseRes.TRANRS.EMAILDN),
      claimAttSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS.CLAIM_ATT)),
      compensationCodes: commonService.arrayTypeReturn(compensationBaseRes.TRANRS.CODES),
      docCompensationLinks: commonService.arrayTypeReturn(docCompensationBaseRes.TRANRS.LINKS.DOC_COMPENSATION),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES)
    };
    return res;
  });

  return result;
};

/**
 * @description 查詢理賠保單號
 */
const fetchClaimPolicyNo = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchClaimPolicyNo(baseReq, reqConfig).then((res: BaseRes<ClaimPolicyNos>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.OPTION;
  }
};

/**
 * @description 新增理賠服務
 */
const AddClaim = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.addClaim(baseReq, reqConfig).then((res: BaseRes<ClaimAddRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res;
  }
};

/**
 * @description 檢核 IMEI 格式
 */
const checkimei = async (imeiSn: string) => {
  const baseReq = commonService.getApiReqData({ IMEI: imeiSn });
  const reqConfig = commonService.getReqConfig();
  const res = await apiService.checkimei(baseReq, reqConfig).then((res: BaseRes<{}>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    return res.MWHEADER.RETURNDESC;
  }

  return '';
};

export default {
  fetchInitSetting,
  fetchClaimPolicyNo,
  AddClaim,
  checkimei
};
